import React from 'react';
import { Container, Box, Typography, Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import Footer from '../../components/Footer/footer';

const branches = [
  { name: 'Jet HomeLoans, Jacksonville', address: '14701 Phillips Hwy, Ste. 202, Jacksonville, FL 32256', phone: '833-270-7191' },
  { name: 'Jet HomeLoans, Home Office/Corporate', address: '13901 Sutton Park Dr South, Ste 101, Jacksonville, FL 32224', phone: '833-270-7191' },
  { name: 'Jet HomeLoans, Maitland/Orlando', address: '2707 West Fairbanks Ave, Ste 200, Winter Park, FL 32789', phone: '833-270-7191' },
  { name: 'Jet HomeLoans, Charlotte', address: '301 McCullough Dr, Ste 400, Charlotte, NC 28262', phone: '833-270-7191' },
  { name: 'Jet HomeLoans, Fayetteville', address: '242 Hay Street, Fayetteville, NC, 28301', phone: '833-270-7191' },
  { name: 'Jet HomeLoans, Bluffton', address: '12 Johnson Way, Ste A & B, Bluffton, SC 29910', phone: '833-270-7191' },
  { name: 'Jet HomeLoans, Charleston', address: '576 Savannah Hwy, Charleston, SC 29401', phone: '833-270-7191' },
  { name: 'Jet HomeLoans, Franklin', address: '3401 Mallory Lane, Ste 100 & 200, Franklin, TN 37067', phone: '833-270-7191' },
  { name: 'Jet HomeLoans, Austin', address: '7200 N MoPac Expy, Ste 400, Austin, TX 78731', phone: '833-270-7191' },
  { name: 'Jet HomeLoans, Herndon', address: '4506 Daly Dr, Ste 100, Chantilly, VA 20151', phone: '833-270-7191' },
  { name: 'Jet HomeLoans, Tucson', address: '130 E Congress St, Ste 200, Tucson, AZ 85701', phone: '833-270-7191' },
  { name: 'Jet HomeLoans, Greenville', address: '355 S. Main Street 1st Floor Office 2298, Greenville, SC 29601', phone: '833-270-7191' },
];

const mapsUrl = (address) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

export default function BranchBusinessProfilesPage() {
  return (
    <>
      <LandingPageNav />
      <Container maxWidth="lg" sx={{ pt: { xs: 10, md: 12 }, pb: { xs: 6, md: 8 } }}>
        <Box>
          <Typography variant="h3" component="h1" sx={{ fontWeight: 800, mb: 3 }}>
            Jet HomeLoans, Branch Addresses
          </Typography>
          <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
            <Table aria-label="branch addresses table" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700 }}>Branch Name</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Property Address</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Phone</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {branches.map((b) => (
                  <TableRow key={b.name} hover>
                    <TableCell>{b.name}</TableCell>
                    <TableCell>
                      <Link href={mapsUrl(b.address)} target="_blank" rel="noopener noreferrer" underline="hover">
                        {b.address}
                      </Link>
                    </TableCell>
                    <TableCell>
                      <Link href={`tel:${b.phone.replace(/[^\d]/g, '')}`} underline="hover">{b.phone}</Link>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Typography variant="caption" sx={{ display: 'block', mt: 2 }} color="text.secondary">
            Click an address to open it in Google Maps, or tap a phone number to call.
          </Typography>
        </Box>
      </Container>
      <Footer />
    </>
  );
}
